// @ts-nocheck
import { useEffect, useState } from "react";
import { breakpointsValues } from "@store/Themes/common/styleguide/config/breakpoints";

const getBreakpointFromMatchMedia = (values: number[]): number | null => {
    for (let i = values.length - 1; i >= 0; i--) {
        if (window.matchMedia(`(min-width: ${values[i]}px)`).matches) {
            return i;
        }
    }
    // Store Custom Code - breakpoint index will not reset to 0 on resize
    return null;
};

export default () => {
    const values = breakpointsValues;
    const [currentBreakpoint, setCurrentBreakpoint] = useState<number | null>(null);

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }

        const mediaQueryLists = values.map((value: number) => window.matchMedia(`(min-width: ${value}px)`));

        const handleChange = () => {
            setCurrentBreakpoint(getBreakpointFromMatchMedia(values));
        };

        handleChange();

        mediaQueryLists.forEach(mql => mql.addEventListener("change", handleChange));

        return () => {
            mediaQueryLists.forEach(mql => mql.removeEventListener("change", handleChange));
        };
    }, []);

    if (typeof window === "undefined") {
        return null;
    }

    if (currentBreakpoint === null) {
        return getBreakpointFromMatchMedia(values);
    }
    return currentBreakpoint;
};
